export const REMOTE_URL = "";
export const GET_JOB_URL = "/api/v1/measure_units/index";
export const ADD_JOB_URL = "/api/v1/measure_units/create";
export const UPD_JOB_URL = "/api/v1/measure_units/update";
